import * as React from 'react';

interface Props {
    size?: number;
    color?: string;
}

export class ContactUsIcon extends React.Component<Props, {}> {

    public static defaultProps: Partial<Props> = {
        size: 16,
    };

    public render(): JSX.Element {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="1695.158 4880 21.842 27.946"
                height={this.props.size}
                width={this.props.size}
            >
                <path id="online-help" fill={this.props.color} d="M87.816,10.144C87.644,4.52,83.371,0,78.131,0c-5.288,0-9.595,4.6-9.693,10.3A3.734,3.734,0,0,0,71.21,16.79a1.193,1.193,0,0,0,.919.454,1.212,1.212,0,0,0,.24-.024,1.194,1.194,0,0,0,.779-.551,8.689,8.689,0,0,0,2.451,2.7v.836a3.525,3.525,0,0,1-2.283,3.3.455.455,0,0,0-.247.628c2.513,5.081,7.6,5.081,10.115,0a.454.454,0,0,0-.247-.628A3.523,3.523,0,0,1,81.27,22.2a2.253,2.253,0,0,1-1.2.353H78.13a2.333,2.333,0,0,1,0-4.666h1.94a2.246,2.246,0,0,1,.505.065l.078.02a2.291,2.291,0,0,1,.835.416,4.031,4.031,0,0,0,.4-.076,10.222,10.222,0,0,0,1.267-1.718,1.173,1.173,0,0,0,.96.5h.009a1.193,1.193,0,0,0,.919-.454,3.745,3.745,0,0,0,.64-.013,5.169,5.169,0,0,1-4.582,2.811h-.026a1.274,1.274,0,0,0-1.01-.518H78.13a1.3,1.3,0,1,0,0,2.592h1.94A1.274,1.274,0,0,0,81.081,21h.026a6.746,6.746,0,0,0,6.552-5.187,3.711,3.711,0,0,0,1.224-1.852c.029-.1.071-.193.092-.3A3.744,3.744,0,0,0,87.816,10.144Zm-3.2-1.334a6.6,6.6,0,0,0-13,.123,1.184,1.184,0,0,0-.931-.255A7.49,7.49,0,0,1,85.541,8.53,1.17,1.17,0,0,0,84.616,8.81Z" transform="translate(1627.949 4880)"/>
            </svg>

        );
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/ContactUsIcon.tsx